import { useState } from 'react';

import './App.css';
import QuestionView from './components/QuestionView';
import Questions from './question.json';
import FormularView from './components/FormularView';

function App() {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [isOver, setIsOver] = useState(false);
  const [questionList, setQuestionList] = useState(Questions);
  const [questionLength, setQuestionLength] = useState(Questions.questions.length);
  const [progressBar, setProgressBar] = useState(0);
  const [selectedQuestion, setSelectedQuestion] = useState([]);

  const [isEducation, setIsEducation] = useState(false);


  const handleQuestionSelectClick = (selected) => {
    let next = currentQuestion + 1;

    if(selected == "Ausbildung"){
      setIsEducation(true)
    }

    if(currentQuestion == 1){
      setIsEducation(false)
    }


    if(next < questionLength){
      setCurrentQuestion(next);
    }else{
      setIsOver(true);
    }

    if(next >= 1){
      progress();
    }

    window.scrollTo(0, 0);
    saveSelectedQuestion(selected);

  };


  const saveSelectedQuestion = (selected) => {
    setSelectedQuestion([...selectedQuestion, selected]);
    console.log(selectedQuestion);
  };

  const progress = () => {
    const value = (currentQuestion + 1) / questionLength;
    setProgressBar(value * 100);
  }

  
  return (
    <div className="App">
      {isOver ? (
          <FormularView SelectedQuestion={selectedQuestion} />
      ): (
        <QuestionView 
        Questions={questionList}
        currentQuestion={currentQuestion}
        questionLength={questionLength}
        progressBar={progressBar}
        educationStatus={isEducation}
        handleQuestionSelectClick={handleQuestionSelectClick}
      />
      )}
    </div>
  );
}

export default App;